import { Nav } from '../..';
import { NavAmplitudeAttributes } from '../../helper';
import * as S from './style';

interface Props {
  navData: Nav[];
  activeValue?: string;
  dataAttributes: NavAmplitudeAttributes[];
  onClick?: (nav: Nav) => void;
}

export default function ModalNav({ navData, activeValue, onClick, dataAttributes }: Props) {
  const handleClick = (nav: Nav) => {
    if (onClick) {
      onClick(nav);
    }
  };

  if (!navData) {
    return null;
  }

  return (
    <S.Wrapper>
      {navData.map((nav, index) => (
        <S.Menu
          key={index}
          isActive={activeValue === nav.value}
          onClick={() => handleClick(nav)}
          {...dataAttributes[index]}>
          <span>{nav.label}</span>
        </S.Menu>
      ))}
    </S.Wrapper>
  );
}
